import { User } from '../../../generated/graphql';

const state: {
  user: User | null;
} = {
  user: null
};
export default state;
